import { defineComponent as _defineComponent } from 'vue'
import { Event } from '@/models/Event';
import KpIcon from '../KpIcon.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'EventModeIndicator',
  props: {
    event: null
  },
  setup(__props: any) {

const props = __props as {
    event: Event;
};

/**
 * A small indicator UI that shows the Event Mode (event.event_mode).
 * Note: Only modes 'mixed' and 'online' are displayed, the 'normal' mode
 * is just output as an empty span.
 */


return { __sfc: true,props, KpIcon }
}

})